import { MessageBus } from "./bus";

/** The one page-level bus. Components import it directly; pages reach it via `window.granrojo.bus`. */
export const bus = new MessageBus();
